<template>
  <v-expand-transition>
    <v-banner v-if="visible" color="grey lighten-5" mobile-breakpoint="600">
      <v-avatar slot="icon">
        <v-icon :color="iconColor" large>{{ icon }}</v-icon>
      </v-avatar>

      <v-col class="pa-0">
        <div class="text-subtitle-1">{{ title }}</div>
        <div class="text-body-2">{{ message }}</div>
      </v-col>

      <template v-slot:actions>
        <v-btn v-if="confirmBtnText" text>
          {{ confirmBtnText }}
        </v-btn>
        <v-btn icon @click="onClose"><v-icon>close</v-icon></v-btn>
      </template>
    </v-banner>
  </v-expand-transition>
</template>

<script>
import { mapGetters } from 'vuex';
import BannerJs from '@/objects/Banner';

export default {
  name: 'Banner',
  computed: {
    ...mapGetters({
      visible: 'banner/visible',
      type: 'banner/type',
      title: 'banner/title',
      message: 'banner/message',
      icon: 'banner/icon',
      iconColor: 'banner/iconColor',
      confirmBtnText: 'banner/confirmBtnText',
    }),
  },
  methods: {
    onClose() {
      BannerJs.close();
    },
  },
};
</script>
